import { Callout, DirectionalHint } from "@fluentui/react/lib/Callout";
import { ColorPicker } from "@fluentui/react/lib/ColorPicker";
import { FocusTrapZone } from "@fluentui/react/lib/FocusTrapZone";
import { TextField } from "@fluentui/react/lib/TextField";
import React from "react";
import { useRef, useState } from "react";
export const ColorSelector = (props) => {
    const [show, setShow] = useState(false);
    const ref = useRef();
    return React.createElement("div", { ref: ref },
        React.createElement(TextField, { readOnly: true, iconProps: { iconName: 'Color' }, label: props.label || '', onClick: () => setShow(true), value: props.value || '' }),
        show && React.createElement(Callout, { isBeakVisible: false, style: { outline: 'none', overflow: 'hidden' }, gapSpace: 0, doNotLayer: true, target: ref, directionalHint: DirectionalHint.bottomLeftEdge, onDismiss: () => setShow(false) },
            React.createElement(FocusTrapZone, { isClickableOutsideFocusTrap: true },
                React.createElement(ColorPicker, { color: props.value, onChange: (_, value) => {
                        props.onChanged('#' + value.hex);
                    } }))));
};
